module.exports = __webpack_public_path__ + "img/BSB_220_L_age5-Marissa.b197eade.jpg";